export const USE_INVOICES_OVERVIEWS_QUERY_KEY = 'invoices-overviews';
export const INVOICES_OVERVIEWS_PAGE_SIZE = 50;